import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectTemplateById, setEditId } from "../../../store/roblox/templatesSlice";
import { destroyTemplate, fetchTemplate } from "../../../actions/roblox/templatesActions";
import robloxUrls from "../../../configs/roblox/robloxUrls";

import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Details from "./_partials/_Details";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";
import EditComment from "../Comments/Edit";

const Show: React.FC = () => {
  const { id }      = useParams();
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const template = useAppSelector(state => id ? selectTemplateById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchTemplate(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    dispatch(setEditId(id));
  }

  function onClickDestroy() {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyTemplate(id));

    if (destroyTemplate.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(robloxUrls.templatesPath()), 1000);
    }

    if (destroyTemplate.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-templates-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            template &&
              <SummaryShow
                title={'Template'}
                image={template.thumbnail_url}
                createdAt={template.created_at}
                updatedAt={template.updated_at}
                className='v-mb-15'
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />,
                ]}
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='stickers'
          items={[
            { label: 'Details', key: 'details', children: <Details template={template} /> },
          ]}
        />
      </div>

      <SidebarShow />

      <Edit />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
